import { AxiosError } from 'axios'

/**
 * Extract a server-provided error message from a thrown error, falling back to
 * a caller-supplied advisor-voice string if no usable message is present.
 *
 * Guardian's Container layer returns 4xx bodies in mixed shapes depending on
 * the controller path:
 *   - raw string  ............................  e.g. "Waiver reason is required"
 *   - `{ error: "..." }` ...................... admin-consent / some 500s
 *   - `{ message: "..." }` .................... legacy paths
 *   - ASP.NET ProblemDetails `{ title, detail }` (validation, unhandled exns)
 *
 * The Function App proxy forwards the Container body verbatim, so the same
 * shapes appear at the frontend. Pull the first non-empty string we find.
 */
export function getServerMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'isAxiosError' in err) {
    const axErr = err as AxiosError<unknown>
    const data = axErr.response?.data
    if (typeof data === 'string' && data.trim().length > 0) {
      return data
    }
    if (data && typeof data === 'object') {
      const d = data as Record<string, unknown>
      const candidate =
        (typeof d.message === 'string' && d.message) ||
        (typeof d.error === 'string' && d.error) ||
        (typeof d.detail === 'string' && d.detail) ||
        (typeof d.title === 'string' && d.title) ||
        ''
      if (candidate) return candidate
    }
  }
  return fallback
}
